<div class="organisation-care-programs-tab" data-testid="organisation-care-programs-tab">
    @if (!isActive) {
        <div class="alert alert-info" role="status" data-testid="organisation-care-programs-inactive">
            This organisation is {{ organisation?.deletedAt ? 'deleted' : 'deactivated' }}. Linked care programmes cannot be viewed or changed.
        </div>
    } @else if (loading) {
        <spinner></spinner>
    } @else {
        @if (loadError) {
            <div class="alert alert-warning" role="alert" data-testid="organisation-care-programs-error">{{ loadError }}</div>
        } @else if (rows.length === 0) {
            <p class="text-muted" data-testid="organisation-care-programs-empty">No care programmes linked</p>
        } @else {
            <div class="table-responsive">
                <table class="table table-sm align-middle" data-testid="organisation-care-programs-table">
                    <caption class="visually-hidden">Care programmes linked to this organisation</caption>
                    <thead>
                        <tr>
                            <th scope="col">Title</th>
                            <th scope="col">Scope</th>
                            <th scope="col">Target</th>
                            <th scope="col">Duration (weeks)</th>
                            <th scope="col">Modules</th>
                            <th scope="col">Added on</th>
                            @if (canWrite) {
                                <th scope="col">Actions</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of rows; track row.id) {
                            <tr data-testid="organisation-care-program-row">
                                <td>{{ row.title }}</td>
                                <td>{{ row.scope }}</td>
                                <td>{{ row.target }}</td>
                                <td>{{ row.durationInWeeks }}</td>
                                <td>{{ row.numberOfModules }}</td>
                                <td>{{ row.addedOn | date: 'dd/MM/yyyy' }}</td>
                                @if (canWrite) {
                                    <td>
                                        <button type="button" class="btn btn-link link-danger p-0 align-baseline"
                                                [attr.aria-label]="'Unlink care programme ' + row.title"
                                                [disabled]="removing"
                                                confirmHeader="Confirm the action"
                                                confirmModal="Are you sure you want to unlink the selected care programme from this organisation?"
                                                [confirmMessage]="row.title"
                                                confirmOk="Yes, proceed"
                                                confirmCancel="No, cancel"
                                                confirmOkClass="btn-outline-danger"
                                                confirmCancelClass="btn-gray text-dark"
                                                [confirmCancelFirst]="true"
                                                (confirmedClick)="unlink(row)"
                                                data-testid="organisation-care-program-unlink">
                                            <i class="bi bi-x-lg" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (canWrite) {
            <div class="organisation-care-programs-actions">
                <button type="button" class="btn btn-success" #linkButton
                        [disabled]="removing"
                        (click)="openLinkModal()"
                        data-testid="organisation-care-programs-link">
                    <i class="bi bi-link-45deg me-2" aria-hidden="true"></i>Link care programmes
                </button>
            </div>
        }
    }
</div>
